import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { ProcessProps } from "../../../types/ProcessTypes";

import { Resizable } from "re-resizable";

import AddBackground from "../../../components/AddBackground";
import SubmitedForm from "../../../components/SubmitedForm";
import { DocsSide } from "../../../components/DocsSide";
import { StepForm } from "../../../components/StepForm";

import api from "../../../services/api";

import { Container, Content } from "../../Digitador/Consulta/styles";
import { insertTypistData } from "../../../services/process";
import { notify } from "../../../components/Toast";
import { AxiosError } from "axios";

function Consulta() {
	const { id: processId, place }: { id: string; place: "1" | "2" } =
		useParams();
	const [process, setProcess] = useState<ProcessProps>();
	const history = useHistory();

	useEffect(() => {
		async function loadProcess() {
			try {
				const { data } = await api.get(`/data/process&id=${processId}`);
				if (data.data) {
					const processData = data.data;
					setProcess(processData);
				}
			} catch (error) {
				return error;
			}
		}
		loadProcess();
	}, []);

	const handleFormSend = async (data: any) => {
		try {
			const promise = insertTypistData(Number(processId), data, place);
			const response = await notify({
				type: "promise",
				promise,
				message: {
					pending: "Enviando dados...",
					success: "Dados enviados com sucesso!",
					error: "Ocorreu um erro no envio dos dados",
				},
			});
			if (response instanceof Error) {
				console.log("ERRO NO ENVIO DO PROCESSO");
				return;
			}
			history.push("/gerenciamento-de-processos");
			// console.log('VOU DAR PUSH')
		} catch (error) {
			return error;
		}
	};

	return (
		<Container>
			<Content className='content'>
				<Resizable
					defaultSize={{ width: "35%", height: 200 }}
					minWidth={"30%"}
					minHeight={"100%"}
					maxWidth={"40%"}>
					<StepForm
						process={process}
						handleFormSend={handleFormSend}
					/>
				</Resizable>

				<DocsSide docs={process?.documents} />
			</Content>

			<AddBackground className='hidden'>
				<SubmitedForm />
			</AddBackground>
		</Container>
	);
}

export default Consulta;
